import React, {Component} from "react";
import {compose} from "redux";
import {withTranslation} from "react-i18next";
import { MdExpandLess, MdExpandMore } from 'react-icons/md';


class HealthMeasuresTabComposed extends Component {
    constructor(props) {
        super(props);
        this.state = {

        };
    }
    onValueChange = (name,value) => {
        this.props.onValueChange(name,value)
    }
    render() {
        let {entry} = this.state

        return (

            <div>
{/*
                <div className={'adminMargin'}>
*/}

                    <h3> TODO</h3>

{/*
                </div>
*/}

            </div>
        );
    }
}



const HealthMeasuresTab = compose(
    withTranslation(),
    /*connect(
        mapStateToProps,
        mapDispatchToProps
    )*/
)(HealthMeasuresTabComposed);

export default HealthMeasuresTab;

